import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import UVTTipoSelect from "./UVTTipoSelect.js"

import { Label, Input, FormFeedback } from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.proyectos.config.presupuesto.uvt.create}
                onSubmit={(res) => this.props.onSubmit(res)}
                successMessage={"La Unidad de Vinculación ha sido creada con éxito."}
                title={"Nueva Unidad de Vinculación"}
                buttonTitle={"Nueva Unidad de Vinculación"}
                buttonIcon={"fa fa-plus fa-lg"}

                buttonLabel={this.props.label}
                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-md"}>
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos de vinculación</p>
                        <div className="ui-row-2">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input type="text" name="nombre" autoFocus data-auto-focus="true"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                            <div className="ui-field">
                                <Label>Tipo</Label>
                                <UVTTipoSelect />
                            </div>
                        </div>
                        <div className="ui-row-2">
                            <div className="ui-field">
                                <Label>Email</Label>
                                <Input type="text" name="email"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                            <div className="ui-field">
                                <Label>Porcentaje</Label>
                                <Input type="number" name="porcentaje"></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_UVT/Create.js